import { useEffect, useState } from 'react'

import { applyTheme, readTheme, THEMES } from '../theme'
import type { Theme } from '../theme'
import { t } from '../i18n/lingua'

/**
 * Selettore del tema: chiaro, scuro o quello di sistema.
 *
 * Tre stati e non un interruttore a due: "sistema" è l'impostazione giusta per
 * chi ha già configurato il passaggio automatico al buio la sera, e un
 * interruttore binario glielo toglierebbe senza dare nulla in cambio.
 *
 * Lo stato iniziale si rilegge da `localStorage` invece di essere ereditato da
 * un contesto: la scelta è già applicata al documento dallo script in
 * `index.html`, prima ancora che React parta.
 */
export default function ThemeSwitch({ variant = 'topbar' }: { variant?: 'topbar' | 'inline' }) {
  const [theme, setTheme] = useState<Theme>(readTheme)

  // Sincronizza le altre schede aperte: cambiare tema in una e ritrovare
  // l'altra com'era è un difetto piccolo ma visibile a chi lavora su due
  // finestre affiancate.
  useEffect(() => {
    function onStorage(event: StorageEvent) {
      if (event.key !== 'censo.theme') return
      const next = readTheme()
      setTheme(next)
      applyTheme(next)
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  function change(next: Theme) {
    setTheme(next)
    applyTheme(next)
  }

  return (
    <select
      className={variant === 'topbar' ? 'topbar__select' : undefined}
      value={theme}
      onChange={(e) => change(e.target.value as Theme)}
      aria-label={t('Tema della console')}
      title={t('Tema della console')}
    >
      {THEMES.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}
